(function () {
  var SECTION_SELECTOR = '.oddit-section-featured-reviews';

  function initSection(section) {
    var track = section.querySelector('.oddit-section-featured-reviews__track');
    var progressFill = section.querySelector('.oddit-section-featured-reviews__progress-fill');
    var prevBtn = section.querySelector('.oddit-section-featured-reviews__arrow--prev');
    var nextBtn = section.querySelector('.oddit-section-featured-reviews__arrow--next');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('.oddit-section-featured-reviews__card'));
    if (!slides.length) return;

    function getStep() {
      if (slides.length < 2) return track.clientWidth;
      return slides[1].getBoundingClientRect().left - slides[0].getBoundingClientRect().left;
    }

    function updateProgress() {
      if (!progressFill) return;
      var maxScroll = track.scrollWidth - track.clientWidth;
      var ratio = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
      var widthPercent = Math.min(100, Math.max(10, ratio * 100));
      // Show portion of visible slides relative to total — minimum 25% indicator
      var visibleRatio = track.clientWidth / track.scrollWidth;
      var fillPercent = Math.max(visibleRatio * 100, widthPercent);
      progressFill.style.width = fillPercent + '%';
    }

    function updateArrowStates() {
      if (!prevBtn || !nextBtn) return;
      var maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.disabled = track.scrollLeft <= 1;
      nextBtn.disabled = track.scrollLeft >= maxScroll - 1;
    }

    function scrollByStep(direction) {
      var step = getStep();
      if (!step) return;
      track.scrollBy({ left: step * direction, behavior: 'smooth' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollByStep(-1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollByStep(1);
      });
    }

    track.addEventListener('scroll', function () {
      updateProgress();
      updateArrowStates();
    }, { passive: true });

    window.addEventListener('resize', function () {
      updateProgress();
      updateArrowStates();
    });

    // Desktop mouse drag-to-scroll (touch keeps native scroll-snap).
    setupDrag(track);

    requestAnimationFrame(function () {
      updateProgress();
      updateArrowStates();
    });
  }

  // Mouse drag-to-scroll for a native overflow-x track. Mouse only — touch keeps
  // native scroll-snap. Suppresses the click that ends a drag so cards/links
  // inside the track don't activate.
  function setupDrag(track) {
    var dragActive = false;
    var dragMoved = false;
    var startX = 0;
    var lastX = 0;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      if (typeof e.button === 'number' && e.button !== 0) return;
      if (track.scrollWidth - track.clientWidth <= 1) return; // nothing to scroll
      dragActive = true;
      dragMoved = false;
      startX = e.clientX;
      lastX = e.clientX;
      track.classList.add('is-dragging');
    });

    window.addEventListener('pointermove', function (e) {
      if (!dragActive) return;
      var dx = e.clientX - lastX;
      lastX = e.clientX;
      if (Math.abs(e.clientX - startX) > 4) dragMoved = true;
      track.scrollLeft -= dx;
    });

    function endDrag() {
      if (!dragActive) return;
      dragActive = false;
      track.classList.remove('is-dragging');
    }
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);

    // Prevent the browser's native drag of links/images inside the track, so a
    // drag can begin even when the pointer starts on a card link or image.
    track.addEventListener('dragstart', function (e) {
      e.preventDefault();
    });

    track.addEventListener('click', function (e) {
      if (dragMoved) {
        e.preventDefault();
        e.stopPropagation();
        dragMoved = false;
      }
    }, true);
  }

  function initAll(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll(SECTION_SELECTOR);
    Array.prototype.forEach.call(sections, initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();